<app-page-loader></app-page-loader>
<router-outlet *ngIf="showPage"></router-outlet>
